import authApi from '@/authApi';
import { useI18n } from '@/i18n';
import { useRouter } from '@/router';

export function useForgotPassword () {
  const i18n = useI18n();
  const router = useRouter();
  return {
    async requestReset ({ username, reCaptchaResponse }) {
      const res = await authApi.post('password-resets', {
        username,
        reCaptchaResponse
      });
      if (!res) {
        return i18n.t('login.network-error');
      } else if (res.status === 204) {
        // We tried our best to submit the request, but we need to make sure
        // the user understands they may not get the email in certain situations.
        router.push('/forgot-password-confirmation');
      } else if (res.status === 422) {
        return res.data.errors[0].message;
      } else {
        return i18n.t('login.unexpected-error');
      }
    },
    async verifyResetToken ({ token }) {
      const res = await authApi.get(`password-resets/${token}`);
      if (res && res.status === 204) return;
      // The token is invalid so we can suggest they try requesting again
      router.replace({
        name: 'ForgotPassword',
        params: {
          errorMessage: i18n.t('login.invalid-reset-token')
        }
      });
    },
    async resetPassword ({ token, password }) {
      const res = await authApi.put(`password-resets/${token}`, {
        password: password
      });
      if (!res) {
        return i18n.t('login.network-error');
      } else if (res.status === 204) {
        // User entered through a password reset link so we don't know where to send them
        router.replace('/login');
      } else if (res.status === 422) {
        // Client validation should prevent this but we still want to show
        // a more descriptive error message in case we made a server-side mistake.
        return res.data.errors[0].message;
      } else {
        return i18n.t('login.unexpected-error');
      }
    }
  };
}
